import { sentenceCase } from "./sentence-case";

export const toTitleCase = (str: string) => {
  const words = str.replace(/\s{2,}/g, " ").split(" ");
  const fixedCaseWords = words.map(sentenceCase);
  const fixedStr = fixedCaseWords.join(" ");

  return fixedStr;
};
